
















































































import { Component, Vue } from "vue-property-decorator";
import SoundManager from "../soundManager";
const VueProps = Vue.extend();
@Component<GameInfo>({})
export default class GameInfo extends VueProps {
  get isEn() {
    return this.$i18n.locale == "en";
  }
  public link(idx: number) {
    SoundManager.btnSound();
    console.log("link", idx);
    this.$emit("link", idx);
  }
  public close(): void {
    SoundManager.btnSound();
    console.log("close");
    this.$emit("close");
  }
}
